const initialState = {
    
    isReflow:false,
    fetchDate:false,
    reflowRes:"",
    reflowmon:"",
    reflowDuedate:"",
    reflowArrivalTime:"",
}

function reflowTool(state = initialState, action) {
    switch (action.type) {    	
            
        case 'REFLOW_RESPONSE':
            return Object.assign({}, state, {
                isReflow: action.value
            })
        case 'REFLOW_ACTUAL_RESPONSE':
            return Object.assign({}, state, {
                reflowRes: action.value
            })
        case 'REFLOW_MON':
            return Object.assign({}, state, {
                reflowmon: action.value
                })
        case 'REFLOW_DUE_DATE':
            return Object.assign({}, state, {
                reflowDuedate: action.value
                })
        case 'REFLOW_ARRIVAL_TIME':
            return Object.assign({}, state, {
                reflowArrivalTime: action.value
                    })
        case 'FETCH_DATE':
            return Object.assign({}, state, {
                fetchDate: action.value
                    })
        default:
              return state
    }
}
export default reflowTool